/* eslint-disable no-unused-vars */
import React, { useState, useContext, createContext } from 'react';
import ReactNetflixPlayer from 'react-netflix-player';
import { useHistory, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlayCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components/macro';

import {
  Container,
  Group,
  Title,
  SubTitle,
  Text,
  Meta,
  Entities,
  Item,
  Image,
} from './styles/card';

export const FeatureContext = createContext();

export default function Card({ children, ...restProps }) {
  const [showFeature, setShowFeature] = useState(false);
  const [itemFeature, setItemFeature] = useState({});

  return (
    <FeatureContext.Provider
      value={{ showFeature, setShowFeature, itemFeature, setItemFeature }}
    >
      <Container {...restProps}>{children}</Container>
    </FeatureContext.Provider>
  );
}

Card.Group = function CardGroup({ children, ...restProps }) {
  return <Group {...restProps}>{children}</Group>;
};

Card.Title = function CardTitle({ children, ...restProps }) {
  return <Title {...restProps}>{children}</Title>;
};

Card.SubTitle = function CardSubTitle({ children, ...restProps }) {
  return <SubTitle {...restProps}>{children}</SubTitle>;
};

Card.Text = function CardText({ children, ...restProps }) {
  return <Text {...restProps}>{children}</Text>;
};

Card.Entities = function CardEntities({ children, ...restProps }) {
  return <Entities {...restProps}>{children}</Entities>;
};

Card.Meta = function CardMeta({ children, ...restProps }) {
  return <Meta {...restProps}>{children}</Meta>;
};

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  opacity: 1;
  z-index: 9999;
`;

const ModalBody = styled.div`
  position: absolute !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: block;
  width: 800px;
  height: auto;

  max-width: 100%;
  max-height: 100%;
  min-height: 100px;
  min-width: 300px;

  pointer-events: all;
  background: black;
  border-radius: 5px;
  overflow: scroll;

  @media (max-width: 640px) {
    width: 80vw;
  }

  @media (max-width: 768px) {
    width: 65vw;
  }

  @media (max-width: 1024px) {
    width: 55vw;
  }

  @media (max-width: 1450px) {
    max-width: 750px;
    width: 100%;
  }

  &.Modal__invisible {
    z-index: -1;
    pointer-events: none;
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;

const ModalImg = styled.img`
  width: 100%;
  height: 100%;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
`;

const ModalShadow = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 20%;
  background: linear-gradient(
    180deg,
    transparent,
    rgba(14, 14, 14, 0.6),
    $light-black
  );
`;

const ModalButtonswrp = styled.div`
  position: absolute;
  bottom: 10%;
  left: 1.5em;
  display: flex;
  align-items: center;
`;

const ModalButton = styled.button`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-width: 80px;
  background-color: darken(#e50914, 5);
  color: black;
  padding: 10px 16px;
  margin-left: 0;
  border-radius: 6px;
  border: 0;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease-out;

  @media (max-width: 400px) {
    min-width: 50px;
    font-size: 14px;
    padding: 12px 20px;
  }

  @media (max-width: 768px) {
    font-size: 15px;
    height: 35px;
  }

  &:hover {
    background-color: white;
  }

  span {
    margin-left: 8px;
  }
`;

const ModalSpan = styled.span`
  color: black !important;
  text-decoration: none !important;
`;

const ModalWrp = styled.div`
  position: relative;
`;

const ModalClosebtn = styled.div`
  position: absolute;
  top: 2%;
  right: 2%;
  z-index: 1;
  display: inline-flex;
  padding: 8px;

  border-radius: 50%;
  cursor: pointer;
  margin: 0 5px;
  margin-bottom: 0.8em;

  color: black;
  transition: all 0.3s ease-out;
  outline: none;

  &:hover {
    color: white;
  }
`;

const ModalInfoWrp = styled.div`
  padding: 1em 1.5em;
  color: white;

  @media (max-width: 640px) {
    padding: 1.5em 2em;
  }
`;

const ModalInfoTitle = styled.h3`
  font-size: 2.25rem;
  line-height: 1.4;
  font-weight: 600;

  @media (max-width: 640px) {
    font-size: 2.25rem;
  }
`;

const ModalInfoDescription = styled.p`
font-size: 16px;
line-height: 1.7;

@media (max-width: 640px) {
  font-size: 16px;
  line-height: 1.5;
}
  }
`;

const ModalInfoRow = styled.div`
  font-size: 14px;
  line-height: 1.6;
  margin: 0.5em;
  margin-left: 0;
  word-break: break-word;

  &-label {
    color: #777;
  }

  &-description {
    color: #ddd;
  }

  @media (max-width: 640px) {
    font-size: 14px;
    line-height: 1.5;
  }
`;

const ModalAge = styled.span`
  border-color: red;
  padding-top: 1px;
  font-size: 1.25rem;
  padding-bottom: 1px;
  line-height: 1.25rem;
  border-width: 1px;
  margin-left: 0.5rem;
`;

const ModalRecommended = styled.span`
  color: #46d369;
  font-size: 1.25rem;
  padding-top: 1px;
  padding-bottom: 1px;
  line-height: 1.25rem;
  font-weight: 700;
`;

const ModalInfoRowLabel = styled.span`
  font-size: 16px;
  line-height: 1.6;
  margin: 0.5em;
  margin-left: 0;
  word-break: break-word;
  color: #777;
`;

const ModalInfoRowDescription = styled.span`
  font-size: 16px;
  line-height: 1.6;
  margin: 0.5em;
  margin-left: 0;
  word-break: break-word;
  color: #ddd; ;
`;

const ModalLink = styled.a`
  color: white;
`;

Card.Item = function CardItem({ item, children, ...restProps }) {
  const { setShowFeature, setItemFeature } = useContext(FeatureContext);
  const [windowOffset, setWindowOffset] = useState(0);

  return (
    <Item
      onClick={() => {
        setShowFeature(true);
        setItemFeature(item);
        // setWindowOffset(window.scrollY);
        document.body.setAttribute('style', `overflow: hidden;`);
      }}
      {...restProps}
    >
      {children}
    </Item>
  );
};

Card.Image = function CardImage({ ...restProps }) {
  return <Image {...restProps} />;
};

Card.Feature = function CardFeature({ children, category, ...restProps }) {
  const { showFeature, itemFeature, setShowFeature } =
    useContext(FeatureContext);

  return showFeature ? (
    <Modal {...restProps}>
      <ModalBody>
        <ModalClosebtn
          onClick={() => {
            setShowFeature(false);
            document.body.setAttribute('style', '');
          }}
        >
          <FontAwesomeIcon size="2x" icon={faTimesCircle} />
        </ModalClosebtn>
        <ModalWrp>
          <ModalShadow />
          {/* {itemFeature.video ? (
            <ReactNetflixPlayer
              autoPlay
              controls={false}
              fullPlayer={false}
              overlayEnabled={false}
              title={itemFeature.title}
              subTitle={itemFeature.title}
              extraInfoMedia={itemFeature.genre}
              playerLanguage="en"
              dataNext={{
                title: 'Texto a ser exibido',
                description: 'Descrição',
              }}
              titleMedia={itemFeature.title}
              src={itemFeature.video}
            />
          ) : (
            <ModalImg
              src={`/images/${category}/${itemFeature.genre}/${itemFeature.slug}/large.jpg`}
              alt="ee"
            />
          )} */}

          <ModalImg
            src={`/images/${category}/${itemFeature.genre}/${itemFeature.slug}/large.jpg`}
            alt="ee"
          />
          <ModalButtonswrp>
            {itemFeature.video && (
              <ModalButton
                onClick={() => document.body.setAttribute('style', '')}
              >
                <Link
                  style={{ textDecoration: 'none' }}
                  to={{
                    pathname: '/watch',
                    state: {
                      title: itemFeature.title,
                      video: itemFeature.video,
                      genre: itemFeature.genre,
                    },
                  }}
                >
                  <FontAwesomeIcon
                    color="black"
                    size="2x"
                    icon={faPlayCircle}
                  />
                  <ModalSpan>Play </ModalSpan>
                </Link>
              </ModalButton>
            )}
          </ModalButtonswrp>
        </ModalWrp>
        <ModalInfoWrp>
          <ModalInfoTitle>{itemFeature.title}</ModalInfoTitle>

          <ModalRecommended>99.9% recommended</ModalRecommended>
          <ModalAge>{itemFeature.date ? itemFeature.date : 2021}</ModalAge>
          <ModalAge>12+</ModalAge>

          <ModalInfoDescription
            dangerouslySetInnerHTML={{ __html: itemFeature.description }}
          />

          <hr />
          <h4 className="Modal__info--otherTitle">
            Info on {itemFeature.title}
          </h4>
          {itemFeature.link && (
            <ModalInfoRow>
              <ModalInfoRowLabel>Link:</ModalInfoRowLabel>
              <ModalInfoRowDescription>
                <ModalLink
                  href={itemFeature.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {itemFeature.link}
                </ModalLink>
              </ModalInfoRowDescription>
            </ModalInfoRow>
          )}
          {itemFeature.date && (
            <ModalInfoRow>
              <ModalInfoRowLabel>Work date:</ModalInfoRowLabel>
              <ModalInfoRowDescription>
                {itemFeature.date}
              </ModalInfoRowDescription>
            </ModalInfoRow>
          )}

          <ModalInfoRow>
            <ModalInfoRowLabel>Original language:</ModalInfoRowLabel>
            <ModalInfoRowDescription>
              {itemFeature.lang ? itemFeature.lang : 'English'}
            </ModalInfoRowDescription>
          </ModalInfoRow>
          <ModalInfoRow>
            <ModalInfoRowLabel>Age classification:</ModalInfoRowLabel>
            <ModalInfoRowDescription>+12</ModalInfoRowDescription>
          </ModalInfoRow>
        </ModalInfoWrp>

        {children}
      </ModalBody>
    </Modal>
  ) : null;
};
